import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import axios from 'axios';

const Outstanding = ({ customer }) => {
  const [customerId, setCustomerId] = useState('');
  const [outstandingData, setOutstandingData] = useState([]);
  const [error, setError] = useState('');

  const fetchOutstanding = async () => {
    if (customer && customer.customer_id) {
   

    try {
      const res = await axios.get(`https://avinandanserampore.com/api/get_outstanding.php?customer_id=${customer.customer_id}`, {
       
      });
     // console.log( customer.customer_id);
      //console.log(res.data);
      setOutstandingData(res.data);
      setError('');
    } catch (err) {
      setError('Failed to fetch data');
      setOutstandingData([]);
    }
}
else{
    return;
}
  };

  useEffect(() => {
    fetchOutstanding();
  }, [customer.customer_id]);

  return (
    <Box >
      <Typography variant="h4" gutterBottom>Customer Outstanding</Typography>

      

      {error && <Typography color="error">{error}</Typography>}

      {outstandingData.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#1976d2' }}>
              <TableRow>
                <TableCell style={{ color: '#fff' }}>Invoice No</TableCell>
                <TableCell style={{ color: '#fff' }}>Date</TableCell>
               
                <TableCell style={{ color: '#fff' }} align="right">Net Amount</TableCell>
                <TableCell style={{ color: '#fff' }} align="right">Balance</TableCell>
                <TableCell style={{ color: '#fff' }} align="right">Due Balance</TableCell>
                
              </TableRow>
            </TableHead>
            <TableBody>
              {outstandingData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.invoice_no}</TableCell>
                  <TableCell>{row.invoice_date} </TableCell>
                 
                  <TableCell align="right">₹{row.Net_Amount.toFixed(2)}</TableCell>
                  <TableCell align="right">₹{row.balance.toFixed(2)}</TableCell>
                  <TableCell align="right">₹{row.due_balance.toFixed(2)}</TableCell>
                 
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default Outstanding;
